import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1999">
      <div className="dark" data-id="element-2000">
        <Hero data-id="element-2001" />
      </div>
      <WhyUs data-id="element-2002" />
      <Services data-id="element-2003" />
      <HowItWorks data-id="element-2004" />
      <FAQ data-id="element-2005" />
      <Reviews data-id="element-2006" />
      <CtaBanner data-id="element-2007" />
    </main>;
}